// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"63a57e41","548":"06e01688","613":"acc4b807","750":"62dadb0e","822":"94013530","826":"fb6e7c98"}[chunkId] + ".1793856400255.chunk.js";
};